module.exports = __webpack_public_path__ + "static/media/people.c9da49ab.svg";